import React, { useEffect, useState } from "react";
import styles from "./index.module.scss";
import { checkImgExists } from "util/checkImgExists";
import { Button } from "@material-ui/core";
import AddCircleIcon from '@material-ui/icons/AddCircle';

const Card = ({ book = {}, BookContentRepository, addShelf }) => {
  const [imgExists, setImgExists] = useState(false);
  const imgCover = BookContentRepository.getCoverUrls({ bookId: book.bookId });
  const imgErrorPath = "assets/img/cover.jpg";

  useEffect(() => {
    checkImgExists(imgCover)
      .then(() => {
        setImgExists(true);
      })
      .catch(() => {
        setImgExists(false);
      });
  }, []);

  return (
    <li className={styles["list-item"]}>
      <div
        className={styles["list-img"]}
        style={{
          backgroundImage: `url(${imgExists ? imgCover : imgErrorPath})`,
        }}
      />
      <div className={styles["list-bottom"]}>
        <div className={styles["list-title"]}>{book.displayName}</div>
        <div className={styles["list-tool"]}>
          <Button
            className={styles.btn}
						variant="contained"
						startIcon={<AddCircleIcon/>}
            onClick={(event) => addShelf(event, book)}
          >
            加入書櫃
          </Button>
        </div>
      </div>
    </li>
  );
};
export default Card;
